import { Flex, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { BackButton, CopyIcon, GreyContainer, GridContainer } from 'shared/ui';
import classes from './TopUpPage.module.scss';
import { useSelector } from 'react-redux';
import { getCurrentAccountObject } from 'shared/config/store/selectors/account';
import { BIC } from '../const';
import { AccountsSelect } from 'widgets/accounts-select';
import { TopUpWarningModal } from '../components/TopUpWarningModal';
import { useAgreeTopUpMutation } from 'entities/account/api';
import { EMI } from 'shared/model/types';
import { useState, useEffect } from 'react';

const { Text, Title } = Typography;

const TopUpPage: React.FC = () => {
  const { formatMessage: t } = useIntl();
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [agreeTopUp, { isLoading: isAgreeLoading }] = useAgreeTopUpMutation();

  const account = useSelector(getCurrentAccountObject);
  const accountMeta = useSelector((state: any) => state.accounts.WALLESTER.meta);

  // Проверяем, согласился ли пользователь с условиями топ-апа
  useEffect(() => {
    if (accountMeta && accountMeta.agree_top_up !== true) {
      setShowWarningModal(true);
    }
  }, [accountMeta]);

  const handleAgreeTopUp = async () => {
    try {
      await agreeTopUp({ emi: EMI.Wallester }).unwrap();
      setShowWarningModal(false);
    } catch (error) {
      console.error('Failed to agree with top-up terms:', error);
    }
  };

  const items = [
    {
      title: t({ id: 'sections.load.load.sepa.recipient' }) + ':',
      value: account.wallettoTopUpDetails.receiver_name ?? 'N/A',
    },
    {
      title: 'IBAN:',
      value: account.iban,
    },
    {
      title: 'BIC:',
      value: BIC,
    },
    {
      title: t({ id: 'sections.load.load.sepa.paymentDetails' }) + ':',
      value: account.wallettoTopUpDetails.payment_details ?? 'N/A',
    },
  ];

  return (
    <>
      <GridContainer>
        <Flex vertical>
          <BackButton />
          <Flex vertical gap={8} className={classes['wrapper']}>
            <Title level={3} style={{ marginBottom: 20 }}>{t({ id: 'topUp.topUp' })}</Title>
            <Text>{t({ id: 'topUp.description' })}</Text>
            <AccountsSelect
              label={`${t({ id: 'components.accountsDropdown.header' })}:`}
              defaultAccount={String(account.id)}
            />
            <Flex vertical gap={16} className={classes['text']}>
              <Flex vertical gap={8}>
                {items.map((item) => (
                  <GreyContainer
                    title={item.title}
                    action={<CopyIcon value={item.value} />}
                  >
                    <Text>{item.value}</Text>
                  </GreyContainer>
                ))}
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </GridContainer>

      <TopUpWarningModal
        open={showWarningModal}
        onAgree={handleAgreeTopUp}
        loading={isAgreeLoading}
      />
    </>
  );
};

export default TopUpPage;
